import { ApiUrl } from "../utils/modules";

class NotificationServices {
  constructor(api) {
    this.api = api;
  }

  create(data) {
    return this.api.post(ApiUrl + "notification", data);
  }

  getAll() {
    return this.api.get(ApiUrl + "notification");
  }

  getOne(id) {
    return this.api.get(ApiUrl + `notification/${id}`);
  }

  update(id, data) {
    return this.api.put(ApiUrl + `notification/${id}`, data);
  }

  delete(id) {
    return this.api.delete(ApiUrl + `notification/${id}`);
  }

  deleteAll() {
    return this.api.delete(ApiUrl + "notification");
  }

  readOne(id) {
  return this.api.put(ApiUrl + `notification/${id}/read`);
}

readAll(userId) {
  return this.api.put(ApiUrl + "notification/read-all", { userId });
}
}

export default NotificationServices;
